// @core/api/endpoints/userprofile/get_userprofile.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UserprofileResponse,
} from '../../../types/userprofile';

const BASE_PATH = '/userprofile';

/**
 * Get user profile by ID (respects privacy settings)
 * Retrieves a user profile by ID. Visibility is controlled by the profile's privacy settings: public profiles are visible to all, private profiles require owner access or connection.
 */
export async function GetUserprofile(
  profile_id: string,
  options?: RequestOptions
): Promise<UserprofileResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:profile_id`;
  requestPath = requestPath.replace(':profile_id', encodeURIComponent(profile_id));
  const requestOptions = options;
  return client.get<UserprofileResponse>(requestPath, { ...requestOptions });
}
